module.exports = __webpack_public_path__ + "img/LTS_MS.d7fd9291.gif";